import { Call, Strain, makeBid } from "@ravalmatic/bridge-engine/core";

export enum BiddingCellState {
    ENABLE = "enable",
    SELECTED = "selected",
    DISABLED = "disabled"
}

export class BiddingCell extends Phaser.GameObjects.Container {

    private static readonly BACKGROUND_FRAMES = [
        "bidding_cell_clubs",
        "bidding_cell_diamonds",
        "bidding_cell_hearts",
        "bidding_cell_spades",
        "bidding_cell_nt"
    ];

    private static readonly OFF_ICON_FRAMES = [
        "clubs_icon_off",
        "diamonds_icon_off",
        "hearts_icon_off",
        "spades_icon_off",
        "NT_off"
    ];

    private static readonly ON_ICON_FRAMES = [
        "clubs_icon_on",
        "diamonds_icon_on",
        "hearts_icon_on",
        "spades_icon_on",
        "NT_on"
    ];

    public readonly call: Call;

    private readonly background: Phaser.GameObjects.Image;
    private readonly offIcon: Phaser.GameObjects.Image;
    private readonly levelLabel: Phaser.GameObjects.Text;
    private cellState: BiddingCellState;
    private isLegal = true;

    constructor(
        scene: Phaser.Scene,
        level: number,
        private readonly strain: Strain,
        onSelected: (call: Call) => void = () => {},
        initialState = BiddingCellState.ENABLE
    ) {

        super(scene);

        this.call = makeBid(level, strain);
        this.cellState = initialState;
        this.background = new Phaser.GameObjects.Image(
            scene,
            0,
            0,
            "texture_atlas_1",
            BiddingCell.BACKGROUND_FRAMES[strain]
        );
        this.add(this.background);

        this.offIcon = new Phaser.GameObjects.Image(
            scene,
            strain === 4 ? 16 : 18,
            0,
            "texture_atlas_1",
            BiddingCell.OFF_ICON_FRAMES[strain]
        );
        this.offIcon.setVisible(false);
        this.add(this.offIcon);

        this.levelLabel = new Phaser.GameObjects.Text(scene, -22, 0, `${level}`, {
            color: "#0e2d57",
            fontFamily: "Baloo2-SemiBold",
            fontSize: "38px"
        });
        this.levelLabel.setOrigin(.5);
        this.add(this.levelLabel);

        this.background.on(Phaser.Input.Events.POINTER_OVER, () => this.setScale(1.025));
        this.background.on(Phaser.Input.Events.POINTER_OUT, () => this.setScale(1));
        this.background.on(Phaser.Input.Events.POINTER_UP, () => onSelected(this.call));
        this.applyState();
    }

    public setLegal(legal: boolean): this {

        this.isLegal = legal;
        this.background.setVisible(legal);
        this.offIcon.setVisible(!legal);
        this.applyState();
        return this;
    }

    public setState(state: BiddingCellState): this {

        this.cellState = state;
        this.applyState();
        return this;
    }

    public getState(): BiddingCellState {

        return this.cellState;
    }

    private applyState(): void {

        this.setScale(1);
        const selected = this.cellState === BiddingCellState.SELECTED;
        this.levelLabel.setColor(selected ? "#ffe84a" : this.isLegal ? "#0e2d57" : "#536176");
        this.levelLabel.setShadow(0, 0, "#ffe84a", selected ? 4 : 0, false, selected);
        this.offIcon.setFrame(selected
            ? BiddingCell.ON_ICON_FRAMES[this.strain]
            : BiddingCell.OFF_ICON_FRAMES[this.strain]);

        if (this.cellState === BiddingCellState.ENABLE) {
            this.background.setInteractive({ useHandCursor: true });
        } else {
            this.background.disableInteractive();
        }
    }
}